import {
    Component,
    createNgModuleRef,
    Injector,
    OnInit,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'blueprint-designer-home-dynamic-load',
    template: '<ng-container #container></ng-container>',
    standalone: false
})
export class BlueprintDesignerLoadDynamic implements OnInit {
    @ViewChild('container', { read: ViewContainerRef, static: true }) container: ViewContainerRef;


    constructor(
        private route: ActivatedRoute,
        private injector: Injector
    ) { }
    ngOnInit(): void {
        this.loadDynamicComponent();
    }

    async loadDynamicComponent() {
        const routeSegments = this.route.snapshot.url; // Get the route segments
        const lastSegmentIndex = routeSegments.length - 1;
        const componentName = routeSegments[lastSegmentIndex].path; // Extract the last segment

        // Dynamically load the component based on the last segment
        const { BlueprintDesignerModule } = await import('./blueprint-designer.module');
        const componentToLoad = this.getComponentToLoad(BlueprintDesignerModule, componentName);
        const moduleRef = createNgModuleRef(BlueprintDesignerModule, this.injector);
        this.container.createComponent(componentToLoad, { ngModuleRef: moduleRef });
    }

    // Function to map the segment to the respective component
    getComponentToLoad(module: any, componentName: string): any {
        return module.components.blueprintDesignerComponent;
    }

}